import React, { AriaRole } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconWifiOutline } from '@saucelabs/ds-icons';

import { TOOLBAR_TRACKING_NAMES, trackEvent } from '../../../tracking';
import * as globalActions from '../../../actions';
import * as globalSelectors from '../../../selectors';
import selectors from '../selectors';
import GenericButton from './GenericButton';

const WifiButton: React.FC<{ role?: AriaRole }> = ({ role }) => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const {
    deviceToolsDisabled,
    deviceType,
    testType,
  } = useSelector(selectors.toolbarButtonSelector);
  const { wifiEnabled } = useSelector(globalSelectors.mobileSessionSelector);

  const toggleWifi = () => {
    void dispatch(globalActions.toggleMobileDeviceWifi());

    trackEvent(TOOLBAR_TRACKING_NAMES.WIFI, { deviceType, testType });
  };

  return (
    <GenericButton
      disabled={deviceToolsDisabled}
      icon={IconWifiOutline}
      label="Wifi"
      onPress={toggleWifi}
      role={role}
      status={wifiEnabled}
    />
  );
};

WifiButton.displayName = 'WifiButton';

export default WifiButton;
